<template>
  <b-form-group
    :label="label"
    label-for="input-1"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
    :state="state"
    style="margin-top: 15px;"
  >
    <b-form-input v-model="newFormInput" :state="state" trim></b-form-input>
  </b-form-group>
</template>
<script>
export default {
  name: "CustomFormGroup",
  props: {
    label: String,
    inputTag: Intl
  },
  data() {
    return {
      newFormInput: "",
      inputData: {}
    };
  },
  computed: {
    state() {
      this.inputData.index = this.inputTag;
      this.inputData.value = this.newFormInput;
      this.inputData.state = this.newFormInput.length >= 1 ? true : false;
      this.$emit("update-input", this.inputData);
      return this.inputData.state;
    },
    invalidFeedback() {
      if (this.newFormInput.length >= 1) {
        return "";
      } else {
        return "Enter at least 1 character";
      }
    },
    validFeedback() {
      return this.state === true ? "OK" : "";
    }
  }
};
</script>